<dialogContent class="medical-component-search-dialog-content">
  <shared-medical-component-search
    [filterOptions]="searchOptions"
    [isDialog]="true"
    (selectedComponent)="selectedComponent($event)" />
  @if (this.data.sidebarElement?.elementType === flowchartElementType.FlowchartDecisionNode) {
    <mat-icon class="code-icon" matSuffix ttTooltip="{{ 'selectRule' | transloco }}" (click)="openRuleDialog($event)">code</mat-icon>
  }
</dialogContent>
